export default "__VITE_ASSET__yu3k8xsU__"